export enum ParcelOriginEnum {
  SYSTEM = 'SISTEMA',
  APPLICATION = 'APLICAÇÃO',
  SO = 'OS',
  MANUAL = 'MANUAL',
  OTHERS = 'OUTROS'
}

export enum ParcelOriginIdEnum {
  'SISTEMA' = 1,
  'APLICAÇÃO' = 2,
  'OS' = 3,
  'MANUAL' = 4,
  'OUTROS' = 5
}

export function getParcelOriginDescriptionByValue(value: string) {
  const indexOfS = Object.values(ParcelOriginIdEnum).indexOf(
    value as unknown as ParcelOriginIdEnum
  );

  const key = Object.keys(ParcelOriginIdEnum)[indexOfS];

  return key;
}
